import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { MEAL_BASE_URL } from "configs/AppConfig";
import axiosHttp from "services/axiosHttp";
import { message } from "antd";

//CREATE ACTION
export const removeMeal = createAsyncThunk("removeMeal", async ({ id }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.delete(`${MEAL_BASE_URL}menu-item/${id}`);
		message.success(response.data.message);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		message.error(err.response.data.message);
		return rejectWithValue(err.response.data);
	}
});

const MealRemoveSlice = createSlice({
	name: "MealRemoveSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	extraReducers: (builder) => {
		builder.addCase(removeMeal.pending, (state, action) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(removeMeal.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(removeMeal.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export default MealRemoveSlice.reducer;
